'use client'

import { ArrowUpRight, ChevronDown } from 'lucide-react'
import React, { useState } from 'react'

interface ProcessStep {
  title: string
  desc: string
}

interface ServiceProcessProps {
  process: ProcessStep[]
  gradient: string
}

/* 
  ServiceProcess - Based on "Variant 3: Interactive List"
*/
export default function ServiceProcess({ process, gradient }: ServiceProcessProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)
  if (!process || process.length === 0) return null

  return (
    <section className="relative z-10 w-full">
      <h2 className="home-title mb-8 sm:mb-12">Как мы работаем</h2>

      <div className="flex flex-col">
        {process.map((step, i) => {
          const isOpen = openIndex === i

          return (
            <div
              key={i}
              className="group relative cursor-pointer border-b border-white/5 py-6 transition-colors select-none hover:border-white/20 sm:py-8"
              onClick={() => setOpenIndex(i)}
            >
              {/* Hover Glow Background */}
              <div
                className={`absolute inset-0 hidden bg-gradient-to-r lg:block ${gradient} pointer-events-none scale-x-110 skew-x-12 opacity-0 transition-opacity duration-500 group-hover:opacity-[0.02]`}
              />

              <div className="relative z-10 flex flex-col gap-4 px-4 sm:gap-6 md:flex-row md:items-baseline">
                <span className="home-caption w-24 shrink-0 pt-2 font-mono text-gray-500 transition-colors group-hover:text-white">
                  0{i + 1}/
                </span>

                <div className="flex-1">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="home-card-title mb-4 leading-tight text-balance text-gray-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-white">
                      {step.title}
                    </h3>
                    <div className="mt-1 md:hidden">
                      <ChevronDown
                        className={`h-5 w-5 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                      />
                    </div>
                  </div>

                  <div
                    className={`max-w-2xl overflow-hidden transition-all duration-500 ease-out ${
                      isOpen
                        ? 'max-h-[1000px] opacity-100'
                        : 'max-h-0 opacity-0 md:group-hover:max-h-[1000px] md:group-hover:opacity-100'
                    }`}
                  >
                    <p className="home-subnote border-l-2 border-white/10 pt-2 pb-2 pl-2 leading-relaxed text-gray-400">
                      {step.desc}
                    </p>
                  </div>
                </div>

                <div className="hidden opacity-0 transition-opacity duration-300 group-hover:opacity-100 md:block">
                  <div
                    className={`flex h-12 w-12 items-center justify-center rounded-full border border-white/20`}
                  >
                    <ArrowUpRight
                      className={`h-5 w-5 text-white transition-transform ${isOpen ? 'translate-x-0.5 -translate-y-0.5' : ''}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
